import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IXenaAppBundle } from 'src/app/xena-api/dtos';
import { IListOptionsFilter } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class XenaAppBundleService extends BaseService<IXenaAppBundle, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'XenaAppBundle');
  }
}
